import { render, staticRenderFns } from "./Protector.vue?vue&type=template&id=0623edbe&scoped=true&"
import script from "./Protector.vue?vue&type=script&lang=js&"
export * from "./Protector.vue?vue&type=script&lang=js&"
import style0 from "./Protector.vue?vue&type=style&index=0&id=0623edbe&scoped=true&lang=css&"
import style1 from "./Protector.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Protector.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623edbe",
  null
  
)

export default component.exports